import { Component, OnInit } from '@angular/core';
import { loadCldr,L10n } from '@syncfusion/ej2-base';
declare var require: any;

loadCldr(
  require('cldr-data/main/de/numbers.json'),
  require('cldr-data/main/de/currencies.json'),
  require('cldr-data/supplemental/numberingSystems.json'),
  require('cldr-data/supplemental/currencyData.json')
);

@Component({
  selector: 'app-berechnung',
  templateUrl: './berechnung.component.html',
  styleUrls: ['./berechnung.component.scss']
})
export class BerechnungComponent implements OnInit {

  public settings_ist = {
    umsatz: 10000000,
    umsatzanteil_direkt: 0.1,
    durchschnittsbestellung_gh: 30,
    netto_spanne_gh: 0.5,
    netto_spanne_direkt: 0.4,
    mindest_bestellwert: 250,
    uebertragungskapazitaet_stunde: 10,
    mitarbeiter_uebertragung: 2,
  };

  public settings_soll = {
    umsatz: 10000000,
    umsatzanteil_direkt: 0.1,
    durchschnittsbestellung_gh: 30,
    netto_spanne_gh: 0.5,
    netto_spanne_direkt: 0.4,
    anzahl_zusatzbestellungen_neu: 1000,
    mindest_bestellwert: 250,
  };

  public berechnung_ist = {
    gesamt_umsatz: 0,
    umsatz_gh: 0,
    umsatz_direkt_ist: 0,
    anzahl_bestellungen_gh: 0,
    anzahl_direktbestellungen_ist: 0,
    rohgewinn_direktbestellungen: 0,
    rohgewinn_gh_bestellungen: 0,
    rohgewinn_gesamt: 0,
    umsatz_anteil_direktbestellungen: 0,
    stundenzahl_uebertrag: 0,
    anteiliges_gehalt: 0,
    rohgewinn_ii: 0,
  };

  public berechnung_soll = {
    gesamt_umsatz: 0,
    umsatz_gh: 0,
    umsatz_direkt_ist: 0,
    anzahl_bestellungen_gh: 0,
    anzahl_direktbestellungen_ist: 0,
    rohgewinn_direktbestellungen: 0,
    rohgewinn_gh_bestellungen: 0,
    rohgewinn_gesamt: 0,
    umsatz_anteil_direktbestellungen: 0,
    stundenzahl_uebertrag: 0,
    anteiliges_gehalt: 0,
    rohgewinn_ii: 0,
    mehrertrag_digibest: 0
  };

  constructor() { }

  ngOnInit(): void {
    this.updateData();
  }

  updateData() {
    this.berechnung_ist.gesamt_umsatz = this.settings_ist.umsatz;

    this.berechnung_ist.umsatz_direkt_ist = (this.settings_ist.umsatzanteil_direkt) * this.berechnung_ist.gesamt_umsatz;
    this.berechnung_ist.anzahl_bestellungen_gh = (this.berechnung_ist.gesamt_umsatz - this.berechnung_ist.umsatz_direkt_ist)/this.settings_ist.durchschnittsbestellung_gh;
    this.berechnung_ist.umsatz_gh = this.berechnung_ist.gesamt_umsatz - this.berechnung_ist.umsatz_direkt_ist;
    this.berechnung_ist.anzahl_direktbestellungen_ist = this.berechnung_ist.umsatz_direkt_ist / this.settings_ist.mindest_bestellwert;
    this.berechnung_ist.rohgewinn_direktbestellungen = (this.settings_ist.netto_spanne_direkt) * this.berechnung_ist.umsatz_direkt_ist;
    this.berechnung_ist.rohgewinn_gh_bestellungen = (this.settings_ist.netto_spanne_gh) * (this.berechnung_ist.gesamt_umsatz - this.berechnung_ist.umsatz_direkt_ist);
    this.berechnung_ist.rohgewinn_gesamt = this.berechnung_ist.rohgewinn_gh_bestellungen + this.berechnung_ist.rohgewinn_direktbestellungen;
    this.berechnung_ist.umsatz_anteil_direktbestellungen = (this.berechnung_ist.umsatz_direkt_ist / this.berechnung_ist.gesamt_umsatz);//*100;
    this.berechnung_ist.stundenzahl_uebertrag = this.berechnung_ist.anzahl_direktbestellungen_ist / this.settings_ist.uebertragungskapazitaet_stunde;
    this.settings_ist.mitarbeiter_uebertragung = this.berechnung_ist.stundenzahl_uebertrag / 400 * 1.5;
    this.berechnung_ist.anteiliges_gehalt = this.settings_ist.mitarbeiter_uebertragung * 520 * 12;
    this.berechnung_ist.rohgewinn_ii = this.berechnung_ist.rohgewinn_gesamt -this.berechnung_ist.anteiliges_gehalt;

    this.berechnung_soll.anzahl_bestellungen_gh = this.berechnung_ist.anzahl_bestellungen_gh - this.settings_soll.anzahl_zusatzbestellungen_neu;
    this.berechnung_soll.anzahl_direktbestellungen_ist = this.berechnung_ist.anzahl_direktbestellungen_ist + this.settings_soll.anzahl_zusatzbestellungen_neu;
    this.berechnung_soll.umsatz_direkt_ist = this.berechnung_soll.anzahl_direktbestellungen_ist * this.settings_soll.mindest_bestellwert;
    this.berechnung_soll.rohgewinn_direktbestellungen = this.berechnung_soll.umsatz_direkt_ist * (this.settings_soll.netto_spanne_direkt);
    this.berechnung_soll.umsatz_gh = this.berechnung_soll.anzahl_bestellungen_gh * this.settings_soll.durchschnittsbestellung_gh;
    this.berechnung_soll.rohgewinn_gh_bestellungen = this.berechnung_soll.umsatz_gh * (this.settings_ist.netto_spanne_gh);
    this.berechnung_soll.rohgewinn_gesamt = this.berechnung_soll.rohgewinn_direktbestellungen + this.berechnung_soll.rohgewinn_gh_bestellungen;
    this.berechnung_soll.gesamt_umsatz = this.berechnung_soll.umsatz_direkt_ist + this.berechnung_soll.umsatz_gh;
    this.berechnung_soll.umsatz_anteil_direktbestellungen = (this.berechnung_soll.umsatz_direkt_ist / this.berechnung_soll.gesamt_umsatz);//*100;
    this.berechnung_soll.rohgewinn_ii = this.berechnung_soll.rohgewinn_gesamt;
    this.berechnung_soll.mehrertrag_digibest = this.berechnung_soll.rohgewinn_ii - this.berechnung_ist.rohgewinn_ii;
    console.log(this.berechnung_soll.mehrertrag_digibest);
  }
}
